




































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

export default Vue.extend({
	name: "SimilarList",
	computed: mapState({
		checkInfo: (state: any) => store.getters.getCheckInfo,
		reportType: (state: any) => store.getters.getReportType,
	}),
	data() {
		return {
			recordListLen: 10,
		};
	},
	methods: {
		// 初始化相似列表
		initSimilarList() {
			if (this.reportType === "preservation") {
				this.recordListLen = 5;
			} else if (this.reportType === "simple" || this.reportType === "simple_ft" || this.reportType === "originalText" || this.reportType === "originalText_ft") {
				this.recordListLen = 10;
			}
		},
		// 跳转链接
		toUrl(url: string) {
			if (url) {
				window.open(url, "_blank");
			}
		},
		getReftype() {

		}
	},
	mounted() {
		this.initSimilarList();
	},
});
